export function computeGrade(accuracy, perfect, attempts) {
    if (attempts === 0)
        return "D";
    const perfectRatio = perfect / attempts;
    const composite = accuracy * 0.75 + perfectRatio * 0.25;
    if (accuracy >= 0.97 && perfectRatio >= 0.85)
        return "S";
    if (composite >= 0.9)
        return "A";
    if (composite >= 0.78)
        return "B";
    if (composite >= 0.6)
        return "C";
    return "D";
}
export function gradeColor(grade) {
    switch (grade) {
        case "S":
            return "#fbbf24";
        case "A":
            return "#4ade80";
        case "B":
            return "#22d3ee";
        case "C":
            return "#a78bfa";
        case "D":
            return "#f87171";
    }
}
